export enum ProviderType {
	ORGANISATION,
	BODY,
}
